import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux'
import SolicitudComponent from './SolicitudComponent';
import estilos from './SolicitudComponent.module.css'
import { obtenerTodasLasSolicitudesWithStatusEnviado, AcualizarFormatoAccion, obetenerSolicitudDetalle, obetenerFormatoDetalle } from '../../../redux/AtencionAClienteDucks'
import { getSolicitudByIdInspector } from '../../../redux/DucksUnidadInspeccion/SolicitudesUIF01Duck';
import { getInspectores } from '../../../redux/DucksUnidadInspeccion/InspectoresDuck';

import estilosTabs from '../Asociados/Tabs/TabsInspeccionarComponent.module.css'

function SolicitudesAsignadasComponent(props) {


    const dispatch = useDispatch()
    const solicitudes = useSelector(store => store.AtencionSolicitud.data)
    const solicitudesStatus = useSelector(store => store.AtencionSolicitud.status)
    const solicitudesInspector = useSelector(store => store.SolicitudesUIF01.solicitudes)
    const inspectores = useSelector(store => store.Inspectores.inspectores);
    const usuario = useSelector(store => store.Usuario)
    const idUsuario = usuario.data.user[0]


    const [tabUno, setTabUno] = React.useState(true)
    const [tabDos, setTabDos] = React.useState(false)
    const [tabTres, setTabTres] = React.useState(false)

    React.useEffect(() => {
        if (solicitudesStatus === 0) {
            dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        }
    }, [dispatch, solicitudes.status])

    React.useEffect(() => {
        dispatch(getInspectores())
    }, [])

    const actualizarSolicitudes = () => {
        inspectores.forEach((e) => {
            if (e.login != null) {
                if (e.login.idlogin === idUsuario.id) {
                    dispatch(getSolicitudByIdInspector(e.idinspector))
                }
            }
        })
    }

    React.useEffect(() => {
        inspectores.forEach((e) => {
            if (e.login != null) {
                if (e.login.idlogin === idUsuario.id) {
                    dispatch(getSolicitudByIdInspector(e.idinspector))
                }
            }
        })
    }, [inspectores])

    React.useEffect(() => {
        console.log(solicitudesInspector)
    }, [solicitudesInspector])

    const opcionUno = () => {
        setTabUno(true)
        setTabDos(false)
        setTabTres(false)
    }

    const opcionDos = () => {
        setTabUno(false)
        setTabDos(true)
        setTabTres(false)
    }

    const opcionTres = () => {
        setTabUno(false)
        setTabDos(false)
        setTabTres(true)
    }

    return (
        <>
            <p className='mt-3' style={{ fontSize: '25px' }}>Solicitudes Activas</p>
            <div className={`row text-center ${estilosTabs.tabsCuartoNivel}`}>
                <div className="col">
                    <button className={`btn btn-light ${estilos.block}`} style={{ background: tabUno ? '#68813B' : 'transparent', color: tabUno ? 'white' : 'black' }} onClick={opcionUno}>SOLICITUDES PENDIENTES</button>
                </div>
                <div className="col">
                    <button className={`btn btn-light ${estilos.block}`} onClick={opcionDos} style={{ background: tabDos ? '#68813B' : 'transparent', color: tabDos ? 'white' : 'black' }}>SOLICITUDES FINALIZADAS</button>
                </div>
                {/* <div className="col">
                    <button className={`btn btn-light ${estilos.block}`} onClick={opcionTres} style={{ background: tabTres ? '#68813B' : 'transparent', color: tabTres ? 'white' : 'black' }}>SOLICITUDES OFFLINE (PENDIENTES)</button>
                </div> */}
            </div>
            <br />
            {
                tabUno ?
                    <Fragment>
                        <div className={`${estilos.labelUI} row mb-2`}>
                            <label className={`${estilos.labelUI} mb-2`}>FC-01: DICTAMEN DE CUMPLIMIENTO CON LA NOM INSTALACIONES (PENDIENTES):</label>
                        </div>
                        {

                            solicitudesInspector.map((solicitud, index) => {
                                //console.log(solicitud)
                                if (solicitud.statusdelasolicitud === 1) {
                                    return (
                                        <SolicitudComponent actualizarSolicitudes={actualizarSolicitudes} key={index} solicitud={solicitud} user={2} status={1} tipo={1} statusui={1} offline={false}></SolicitudComponent>
                                    )
                                }
                            })

                        }
                    </Fragment>
                    :
                    tabDos ?
                        <Fragment>
                            <div className={`${estilos.labelUI} row mb-2`}>
                                <label className={`${estilos.labelUI} mb-2`}>FC-01: DICTAMEN DE CUMPLIMIENTO CON LA NOM INSTALACIONES (DICTAMINADAS):</label>
                            </div>

                            {

                                solicitudesInspector.map((solicitud, index) => {
                                    //console.log(solicitud)
                                    if (solicitud.statusdelasolicitud === 2 && !solicitud.isoffline) {
                                        return (
                                            <SolicitudComponent actualizarSolicitudes={actualizarSolicitudes} key={index} solicitud={solicitud} user={2} status={1} tipo={1} statusui={2} offline={false}></SolicitudComponent>
                                        )
                                    }
                                })

                            }
                        </Fragment>
                        :
                        tabTres ?
                            <Fragment>
                                <div className={`${estilos.labelUI} row mb-2`}>
                                    <label className={`${estilos.labelUI} mb-2`}>FC-01: DICTAMEN DE CUMPLIMIENTO CON LA NOM INSTALACIONES (PENDIENTES DE SUBIR AL SISTEMA):</label>
                                </div>
                                {

                                    solicitudesInspector.map((solicitud, index) => {
                                        //console.log(solicitud)
                                        if (solicitud.statusdelasolicitud === 2 && solicitud.isoffline) {
                                            console.log(solicitud)
                                            return (
                                                <SolicitudComponent actualizarSolicitudes={actualizarSolicitudes} key={index} solicitud={solicitud} user={2} status={1} tipo={1} statusui={2} offline={true}></SolicitudComponent>
                                            )
                                        }
                                    })

                                }
                            </Fragment>
                            :
                            <frameElement />
            }


            {/*
            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>FC-09 DICTAMEN DE CUMPLIMIENTO CON LA NOM PARA PRODUCTO DE EXPORTACIÓN:</label>
            </div>
            {JSON.stringify(solicitudes.fc_09_solicitudemicioncertificadonomexportacionyentregahologram)}
            <hr></hr>

            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>FC-30 TRASLADO DE PRODUCTO EN SITIO/DOCUMENTAL</label>
            </div>
            {JSON.stringify(solicitudes.fc_30_notificaciontrasladodeproducto)}
            <hr></hr>

            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>FC-31 SOLICITUD DE SEGUIMIENTO [MUESTREO, AJUSTE DE GRADO, MEZCLA, INGRESO O LIBERACIÓN DE MADURACIÓN]</label>
            </div>
            {JSON.stringify(solicitudes.fc_31_solicitudseguimiento)}
            <hr></hr>

            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>CERTIFICADO NOM PARA VENTA NACIONAL Y ENTREGA DE HOLOGRAMAS</label>
            </div>
            {JSON.stringify(solicitudes.fc_34_notificacionsuspencionyreactivacion)}
            <hr></hr>

            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>FC-34 R3 NOTIFICACIÓN DE SUSPENCIÓN O REACTIVACIÓN</label>
            </div>
            {JSON.stringify(solicitudes.fc_34_notificacionsuspencionyreactivacion)}
            <hr></hr>

            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>FC-35 SERVICIOS VARIOS</label>
            </div>
            {JSON.stringify(solicitudes.fc_35_notificaciondeserviciosvarios)}
            <hr></hr>

            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>FC-36 R3 INFORME PARA AMPLIACIÓN DE INSTALACIONES</label>
            </div>
            {JSON.stringify(solicitudes.fc_36_solicituddeactualizacion)}
            <hr></hr>

            <div className={`${estilos.labelUI} row mb-2`}>
                <label className={`${estilos.labelUI} mb-2`}>FC-41 DICTAMEN DE BEBIDA ALCOHÓLICA QUE CONTIENE MEZCAL</label>
            </div>
            {JSON.stringify(solicitudes.fc_41_solicitudparabebidasconmezcal)}
            <hr></hr>
        */}
        </>
    );
}

export default withRouter(SolicitudesAsignadasComponent)